import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { httpService } from "../httpService";
import { Button, CircularProgress, TextField, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { Badge, Modal } from "react-bootstrap";

function ConfirmPosting() {
  const { id } = useParams();
  const [posting, setPosting] = useState(null);
  const [accepting, setAccepting] = useState(false);
  const [show, setShow] = useState(false);
  const [reason, setReason] = useState("");
  const [declining, setDeclining] = useState(false);
  const [loading, setLoading] = useState(false);

  const getPosting = async () => {
    setLoading(true);
    const { data } = await httpService(`viewposting/${id}`);

    if (data) {
      setPosting(data);
    }
    setLoading(false);
  };

  useEffect(() => {
    getPosting();
  }, []);

  const acceptNomination = () => {
    Swal.fire({
      icon: "question",
      title: "Accept",
      text: "Do you wish to accept this nomination",
      showCancelButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setAccepting(true);
        const { data, error } = await httpService.get(`acceptposting/${id}`);
        if (data) {
          toast.success(data);
          getPosting();
        }
        if (error) {
          toast.error(error);
        }
        setAccepting(false);
      }
    });
  };
  const declineNomination = () => {
    Swal.fire({
      icon: "question",
      title: "Decline",
      text: "Do you wish to decline this nomination",
      showCancelButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setDeclining(true);
        const { data, error } = await httpService.post(`declineposting/${id}`, {
          reason,
        });
        if (data) {
          toast.success(data);
          getPosting();
          setShow(false);
        }
        if (error) {
          toast.error(error);
        }
        setDeclining(false);
      }
    });
  };
  return (
    <div>
      {loading && (
        <div className="text-center">
          <CircularProgress size={20} />
        </div>
      )}
      {posting && (
        <div className="container">
          <div className="mb-3">
            <Typography>You are currently nominated for </Typography>
            <Typography variant="h4" textTransform={"uppercase"}>
              {posting.examination.title}
            </Typography>
            <Typography
              variant="h6"
              textTransform={"uppercase"}
              fontWeight={300}
            >
              {posting.school.school}
            </Typography>
            <Typography variant="h6" textTransform={"uppercase"}>
              {posting.school.state}
            </Typography>
          </div>
          {posting.status === "unconfirmed" ? (
            <div className="row">
              <div className="col-lg-3">
                <LoadingButton
                  onClick={acceptNomination}
                  variant="contained"
                  color="success"
                  loading={accepting}
                >
                  Accept this nomination
                </LoadingButton>
              </div>
              <div className="col-lg-3">
                <Button onClick={() => setShow(true)} color="error">
                  Decline this nomination
                </Button>
              </div>
            </div>
          ) : (
            <>
              <Badge
                className="text-uppercase"
                bg={posting.status === "declined" ? "danger" : "success"}
              >
                {posting.status}
              </Badge>

              {posting.reasonForDecline && (
                <div>
                  <Typography variant="caption">Reason for decline:</Typography>
                  <Typography>{posting.reasonForDecline}</Typography>
                </div>
              )}
            </>
          )}
        </div>
      )}
      <Modal size="lg" show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>DECLINE NOMINATION</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div className="mb-3">
              <Typography>
                Kindly provide your reason for declining this nomination
              </Typography>
            </div>
            <div>
              <TextField
                multiline={true}
                fullWidth
                maxRows={4}
                onChange={(e) => setReason(e.target.value)}
                label="Reason"
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Typography className="me-2" color="error">
            Please note that this action cannot be undone
          </Typography>
          <LoadingButton
            onClick={declineNomination}
            loading={declining}
            variant="contained"
            color="error"
          >
            DECLINE NOMINATION
          </LoadingButton>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ConfirmPosting;
